import {
  ORDERS_STATUS,
  PRODUCT_TYPES,
  SUPPLIER_PROCESS_STATUS,
} from "@/utils/constant";
import { computed, ref, watch } from "@vue/composition-api";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Vue from "vue";
import appUtils from "@/utils/appUtils";
import i18n from "@/libs/i18n";
import store from "@/store";
import { useToast } from "vue-toastification/composition";

export default function useOrdersList() {
  // Use toast
  const toast = useToast();
  const showTable = ref(false);
  const refOrdersTable = ref(null);

  // Table Handlers
  const tableColumns = computed(() => {
    const defaultCols = [
      // { key: "index", label: "#ID", sortable: false },
      { key: "order_code", label: i18n.t("lbl_code"), sortable: false },
      { key: "order_code", label: i18n.t("lbl_code_receipt"), sortable: false },
      { key: "customer", label: i18n.t("lbl_customer"), sortable: false },
      { key: "order_date", label: i18n.t("lbl_order_date"), sortable: false },
      // { key: "address", label: i18n.t("lbl_address"), sortable: false },
      // { key: "phone", label: i18n.t("lbl_phone"), sortable: false },
      {
        key: "delivery_status",
        label: i18n.t("lbl_order_status"),
        sortable: false,
      },
      { key: "test_status", label: i18n.t("lbl_test_status"), sortable: false },
      {
        key: "payment_status",
        label: i18n.t("lbl_payment_status"),
        sortable: false,
      },
      {
        key: "total_order_amount",
        label: i18n.t("Tổng giá trị (VNĐ)"),
        sortable: false,
      },
      {
        key: "transaction_point",
        label: i18n.t("H-Credit"),
        sortable: false,
      },
      {
        key: "transaction_campaign",
        label: i18n.t("Order"),
        sortable: false,
      },
      {
        key: "customer_pay",
        label: i18n.t("Khách hàng trả (VNĐ)"),
        sortable: false,
      },
      // {
      //   key: "slip.number_code",
      //   label: i18n.t("Mã phiếu thu"),
      //   sortable: false,
      // },
      { key: "avatar", label: i18n.t("Followers"), sortable: false },
      // {
      //   key: "return_date",
      //   label: i18n.t("lbl_result_date"),
      //   sortable: false,
      //   thStyle: { padding: "0.72rem 0.5rem" },
      // },
      { key: "action", label: "", thClass: "text-right" },
    ];
    return followMode.value
      ? [{ key: "selecting", label: "", sortable: false }, ...defaultCols]
      : defaultCols;
  });
  const statusFilterOptions = computed(() => [
    {
      value: null,
      text: i18n.t("lbl_all_test_status"),
    },
    {
      value: SUPPLIER_PROCESS_STATUS.not_send,
      text: i18n.t("lbl_supplier_process_status.NOT_SEND"),
    },
    {
      value: SUPPLIER_PROCESS_STATUS.processing,
      text: i18n.t("lbl_supplier_process_status.PROCESSING"),
    },
    {
      value: SUPPLIER_PROCESS_STATUS.completed,
      text: i18n.t("lbl_supplier_process_status.FINISHED"),
    },
    {
      value: SUPPLIER_PROCESS_STATUS.canceled,
      text: i18n.t("lbl_supplier_process_status.CANCELED"),
    },
    // {
    //   value: ORDERS_STATUS.CANCELED,
    //   text: i18n.t("lbl_processor_order_status.CANCELED"),
    // },
  ]);

  const PAYMENT_STATUS_OPTIONS = computed(() => [
    {
      value: null,
      text: i18n.t("lbl_all_payment_status"),
    },
    {
      value: 1,
      text: i18n.t("obj_payment_status.not_payment"),
    },
    {
      value: 2,
      text: i18n.t("obj_payment_status.paid"),
    },
  ]);

  const perPage = ref(10);
  const totals = ref(0);
  const currentPage = ref(1);
  const searchQuery = ref("");
  const followMode = ref(""); // '', 'floating', 'follow'
  const sortBy = ref("order_id");
  const isSortDirDesc = ref(true);
  const outOfStockFilter = ref(null);
  const activeFilter = ref(null);
  const allOpenRows = ref([]);
  const recordDetail = ref(null);
  const showDetailOrder = ref(false);
  const statusFilter = ref(null);
  const paymentStatusFilter = ref(null);
  const fromDate = ref(null);
  const toDate = ref(null);
  const isLoading = ref(false);
  const listOrders = ref(null);

  if (store.state.orders.filterParams.supplier_id) {
    (searchQuery.value = store.state.orders.filterParams.keyword),
      (perPage.value = store.state.orders.filterParams.page_size),
      (currentPage.value = store.state.orders.filterParams.page_num),
      (statusFilter.value = store.state.orders.filterParams.status),
      (paymentStatusFilter.value =
        store.state.orders.filterParams.payment_status),
      (fromDate.value = store.state.orders.filterParams.from_date),
      (toDate.value = store.state.orders.filterParams.to_date);
    followMode.value = store.state.orders.filterParams.followMode;
  }

  const dataMeta = computed(() => {
    const localItemsCount = refOrdersTable.value
      ? refOrdersTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totals.value,
    };
  });

  const refetchData = () => {
    refOrdersTable.value.refresh();
  };

  const fetchOrdersList = (ctx, callback) => {
    isLoading.value = true;
    const userData = appUtils.getLocalUser();

    const params = {
      keyword: searchQuery.value,
      mode: followMode.value,
      page_size: perPage.value,
      page_num: currentPage.value,
      supplier_id: userData?.supplierInfo?.id,
      sort_by: "id",
      order: "desc",
      status_gr: statusFilter.value,
      payment_status: paymentStatusFilter.value,
      from_date: fromDate.value
        ? moment(fromDate.value).startOf("day").valueOf()
        : fromDate.value,
      to_date: toDate.value
        ? moment(toDate.value).endOf("day").valueOf()
        : toDate.value,
      type: PRODUCT_TYPES.SERVICE,
    };

    store
      .dispatch("orders/fetchOrdersList", params)
      .then((response) => {
        const orders = response.result?.data;
        // const orders = responseData?.map((item) => {
        //   const orderItems = item?.order_item?.filter(
        //     (item) => item.product_type === PRODUCT_TYPES.SERVICE
        //   );
        //   return {
        //     ...item,
        //     order_item: orderItems,
        //   };
        // });

        totals.value = response.result?.page?.total;
        listOrders.value = orders;
        callback && callback(orders);
        isLoading.value = false;
      })
      .catch((e) => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("lbl_error_fetching_data"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const getOrderStatus = (status) => {
    switch (status) {
      case ORDERS_STATUS.RECEIVE_ORDERS:
        return {
          classes: "bg-primary text-white",
          icon: "LoaderIcon",
        };
      case ORDERS_STATUS.PROCESSING:
        return {
          classes: "bg-primary text-white",
          icon: "LoaderIcon",
        };
      case ORDERS_STATUS.SENDING:
        return {
          classes: "bg-primary text-white",
          icon: "LoaderIcon",
        };
      case ORDERS_STATUS.FINISHED:
        return {
          classes: "bg-success text-white",
          icon: "CheckIcon",
        };
      case ORDERS_STATUS.CANCELED:
        return {
          classes: "bg-danger text-white",
          icon: "XIcon",
        };
      case ORDERS_STATUS.WAITING_CONFIRM:
        return {
          classes: "bg-light",
          icon: "MoreHorizontalIcon",
        };
      case ORDERS_STATUS.ERROR_PAYMENT:
        return {
          classes: "bg-danger text-white",
          icon: "XIcon",
        };

      default:
        return {
          classes: "bg-white",
          icon: "",
        };
    }
  };

  const viewDetailOrders = async (record) => {
    const res = await store
      .dispatch("orders/fetchOrdersById", { id: record.id })
      .then((response) => {
        showDetailOrder.value = true;
        recordDetail.value = { ...response.result.data };
        recordDetail.value.order_items.forEach((x) => {
          const currentStatus = x.data.status;
          const currentDeliveryStatus = x?.deliverable_status?.find(
            (i) => i.order_number === currentStatus
          );
          x.currentStatus = currentDeliveryStatus;
        });
        store.commit("orders/updateViewDetail", recordDetail.value);
        return recordDetail.value;
      })
      .catch((e) => {
        console.log(e);
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("lbl_error_fetching_data"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return null;
      });
    return res;
  };

  const updateStatusOrder = (ordersId, params) => {
    store
      .dispatch("orders/updateStatusOrder", params)
      .then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("lbl_change_status_order_successfully"),
            icon: "CheckCircleIcon",
            variant: "success",
          },
        });
      })
      .catch((e) => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("lbl_an_error_occurred_while_updating"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        viewDetailOrders({ id: ordersId });
      });
  };

  const uploadFileDefinition = async (
    file,
    order_item_attachment_id,
    ordersId
  ) => {
    const url = await uploadFile(file, order_item_attachment_id);
    if (!url) {
      toast({
        component: ToastificationContent,
        props: {
          title: i18n.t("lbl_an_error_occurred_while_updating"),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
      return;
    }
    const params = {
      order_item_attachment_id,
      url,
    };

    store
      .dispatch("orders/updateAttachmentResult", {
        params,
        callback: () => viewDetailOrders({ id: ordersId }),
      })
      .then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("lbl_upload_file_successfully"),
            icon: "CheckCircleIcon",
            variant: "success",
          },
        });
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("lbl_an_error_occurred_while_uploading"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const uploadFile = async (file, order_item_attachment_id) => {
    const params = {
      file,
      FolderTarget: `attachmentOrderItem`,
      IdTarget: order_item_attachment_id,
    };
    const formData = new FormData();

    for (const key in params) {
      formData.append(key, params[key]);
    }

    const res = await Vue.prototype.$rf
      .getRequest("CommonRequest")
      .uploadFileTenant(formData);
    return res.data.fileUrl;
  };

  const timeout = ref(null);

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      followMode,
      outOfStockFilter,
      activeFilter,
      statusFilter,
      paymentStatusFilter,
      fromDate,
      toDate,
    ],
    () => {
      showTable.value = true;
      clearTimeout(timeout);
      timeout.value = setTimeout(() => {
        refetchData();
        showTable.value = false;
      }, 2000);
    }
  );

  return {
    timeout,
    showTable,
    fetchOrdersList,
    tableColumns,
    perPage,
    currentPage,
    totals,
    dataMeta,
    searchQuery,
    followMode,
    sortBy,
    isSortDirDesc,
    refOrdersTable,
    statusFilterOptions,
    statusFilter,
    refetchData,
    allOpenRows,
    ORDERS_STATUS,
    getOrderStatus,
    viewDetailOrders,
    recordDetail,
    showDetailOrder,
    updateStatusOrder,
    uploadFileDefinition,
    fromDate,
    toDate,
    isLoading,
    PAYMENT_STATUS_OPTIONS,
    paymentStatusFilter,
    listOrders,
    // Extra
  };
}
